// Session-list version state — `sessionQueryVersionAtom` moved verbatim out of
// `src/atoms/sessionAtoms.tsx` (which re-exports from here) with the D1
// family; the rest of that grab-bag file (UI modal atoms etc.) stays
// app-side. LEGACY WRITABLE ATOM EXPORT: recorded in the package's
// LEGACY-ATOM-EXPORTS.md burn-down (arch §5 law 6) — curation to a
// hook/command shape is a named follow-up, never part of the move.
//
// Store identity (the capture lesson): the package's version-dispatched
// COMMANDS (`sessionsListCache.ts`) read this atom via `getDefaultStore()`,
// exactly as the app-side originals did. That pins the contract to the
// production (provider-less) jotai default store — a Provider-scoped store
// would silently diverge. The app runs provider-less today; if that ever
// changes, these commands must take the store as a parameter.

import { atom } from 'jotai';

/**
 * Controls which version of the sessions query hook to use:
 * - v1: Fetches all sessions at once (useQuerySessions.ts)
 * - v2: Fetches in pages with infinite query (useQuerySessionsV2.ts)
 * - v3: Fetches in pages with pagination using infinite query (useQuerySessionsWithPagination.ts)
 */
export const sessionQueryVersionAtom = atom<'v1' | 'v2' | 'v3'>('v2');
